import { occFetch, occUrl } from "~/app/api/occ/occFetch";

const apiUrl = occUrl("/product-comparison/removeAllProducts");

export function sendData() {
  return occFetch(apiUrl, {
    method: "DELETE",
    headers: {
      "content-type": "application/json",
    },
  }).then((res) => {
    if (!res.ok) {
      throw new Error(res.statusText);
    }
    return res;
  });
}
